import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import downloadImage from "../../assests/images/download.png";
import { Switch } from "@mui/material";
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import Modal from "@mui/material/Modal";
import GetAppIcon from "@mui/icons-material/GetApp";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import checkcircleImage from "../../assests/images/check-circle.png";
import holdImage from "../../assests/images/hold.png";
import rejectedImage from "../../assests/images/Rejected.png";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";
import { vendorServices } from "../../services/vendorServices";
import SupportChat from "../support/chat";
import { Backdrop, CircularProgress } from "@mui/material";
import {
  getFileNameByPath,
  getSecPermission,
  isEmptyDash,
  strToDate,
  urlConstants,
} from "../../constant";
import BusinessInformationStep1 from "./businessInformationStep1";
import FinancialTaxStep2 from "./financialTaxStep2";
import TechnicalComplianceStep3 from "./technicalComplianceStep3";
import AlertComponent from "../alert/alert";
import { Link } from "react-router-dom";
import { UserObj } from "../../services/localStarage";
import _ from "lodash";
import { onboardingServices } from "../../services/onboardingServices";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import OnboardingProgress from "./onboardingProgress";
import SuccessModal from "../common/successModal.js";
import back from "../../assests/images/back.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "70%",
  overflowY: "auto",
};

const styleDwnlod = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "70%",
  overflowY: "auto",
  // minWidth: "450px",
};
const progr_pad = { paddingTop: "8px" };
const styleRating = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "70%",
  overflowY: "auto",
};

const steps = [
  "Select master blaster campaign settings",
  "Create an ad group",
  "Create an ad",
];

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function VendorDetails() {
  const { id } = useParams();
  let navigate = useNavigate();

  const storedData = sessionStorage.getItem("user");
  const parsedData = storedData ? JSON.parse(storedData) : null;

  const [isLoading, setIsLoading] = useState(false);

  const [opens1, setOpen1] = React.useState({ isOpen: false, param: "" });

  const handleOpens1 = (param) => {
    setOpen1({ isOpen: true, param: param });
  };
  const handleCloses1 = () => {
    setRating(0);
    setFeedback("");
    setOpen1({ isOpen: false, param: "" });
  };

  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openfactorysucessModal, setFactorySucessModal] = useState(false);
  const [assigedId, setAssigedId] = useState("");
  const [openHoldModal, setOpenHoldModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [opendownloadtModal, setOpenDownloadModal] = useState(false);
  const [openfactoryvisttModal, setOpenFactoryVistModal] = useState(false);
  const [isVendorEdit, setIsVendorEdit] = useState(false);
  const [allStepData, setAllStepData] = useState({ steps: [], tabs: [] });
  const [activeStep, setActiveStep] = useState(0);
  const [isProgressView, setIsProgressView] = useState(false);
  const [allStepTabData, setAllStepTabData] = useState([]);
  const [sectionAssignData, setSectionAssignData] = useState([]);
  const [engineerAssigneeData, setEngineerAssigneeData] = useState([]);
  const [qaAssignData, setQaAssignData] = useState([]);
  const [sectionApprovernData, setSectionApprovernData] = useState();
  const [checked, setChecked] = React.useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [documentDownloadList, setDocumentDownloadList] = useState([]);

  const [activeIndex, setActiveIndex] = useState(0);
  const [stepId, setStepId] = useState("");
  const [sectionData, setSectionData] = useState({ fieldsWithResponses: [] });
  const [vendorDetails, setVendorDetails] = useState({});
  const [visitData, setVisitData] = useState({
    switch: false,
    visitDate: "",
    visitAssign: "",
    visitQAAssign: "",
    // visitEmail: "",
    visitRemarks: "",
  });

  const [openModal, setOpenModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  const [secVendorDetailsPermission, setSecVendorDetailsPermission] = useState({
    "EXISTING_VENDOR_LISTING": permissionInit,
    "REGULAR_NEW_VENDOR_LISTING": permissionInit,
    "DIRECT_NEW_VENDOR_LISTING": permissionInit,
    "WITHOUT_DOC_NEW_VENDOR_LISTING": permissionInit,
    "PROFILE_EVALUATION": permissionInit,

    "FINANCIAL_EVALUATION": permissionInit,
    "FACTORY_EVALUATION": permissionInit,
    "FINAL_RATING": permissionInit,
    "THIRD_PARTY": permissionInit,
    "SAP_FIELDS": permissionInit,
    "EDIT_VENDOR": permissionInit,
  });

  const handleSuccess = (message) => {
    setSuccessMessage(message);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    setStepId(allStepTabData[0]?._id);
  }, [allStepTabData]);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const handleClick1 = (ele, index) => {
    setActiveIndex(index);
    setStepId(ele?._id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleInputChange = (event) => {
    setFeedback(event.target.value);
  };

  useEffect(() => {

    let secVendorDetailsPermissionInit = _.cloneDeep(secVendorDetailsPermission);
    let obj = {};
    for (let key in secVendorDetailsPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecVendorDetailsPermission(obj);

    getInternalVendorDetailsForStep(id, "").then(function (vendorDetailsRes) {

      if (vendorDetailsRes?.success == true) {
        setAllStepData(vendorDetailsRes?.data);


        let activeStep = 0;
        let thirdPartyIndex = -1;
        let isProgressViewInit = false;
        if (
          vendorDetailsRes &&
          vendorDetailsRes.data &&
          vendorDetailsRes.data.steps
        ) {
          for (
            let index = 0;
            index < vendorDetailsRes?.data.steps.length;
            index++
          ) {
            if (
              vendorDetailsRes?.data.steps[index]?._id ==
              vendorDetailsRes?.data?.latestStepId
            ) {
              activeStep = index;
            }
            if (
              vendorDetailsRes?.data.steps[index]?.uniqueName == "thirdParty"
            ) {
              thirdPartyIndex = index;
            }
          }

          if (activeStep >= thirdPartyIndex) {
            isProgressViewInit = true;
          }
          setActiveStep(activeStep);
          setIsProgressView(isProgressViewInit);
          setAllStepTabData(vendorDetailsRes?.data?.steps.slice(0, 3));
          /** Assignee */
          const currentTab = vendorDetailsRes?.data?.steps[activeStep];
          //const currentTab = vendorDetailsRes?.data?.tabs[2];

          if (currentTab) {
            const departments = currentTab.departments.join(',');
            getAssignSteps(`?departments=${departments}`, departments);
          }
          getInternalVendorDetailsForStep(
            id,
            `?stepId=${vendorDetailsRes?.data?.steps[0]._id}`
          ).then(function (vendorDetailsStaepIdRes) {
            if (vendorDetailsRes?.success == true) {
              setSectionData(vendorDetailsStaepIdRes?.data);
              setAssigedId(vendorDetailsStaepIdRes?.data?.assigneeId);
              // getInternalVendorDetailsForStep(id, `?stepId=${vendorDetailsRes?.data?.latestStepId}`)
            }
          });
        } else {
          console.error("something went wrong");
        }
      }
    });
  }, []);

  useEffect(() => {
    getInternalVendorDetailsForStep(id, `?stepId=${stepId}`);
  }, [stepId]);

  useEffect(() => {
  }, [sectionData]);


  useEffect(() => {
    // getAssignSteps("", "All"); 
    getAssignSteps("?departments=QUALITY", "QUALITY");
    getAssignSteps("?departments=ENGINEERING", "ENGINEERING");
    getVendorDetailsById();
  }, []);

  const getInternalVendorDetailsForStep = (vendorId, param) => {
    setIsLoading(true);
    return vendorServices
      .getInternalVendorDetailsForStep(vendorId, param)
      .then(function (response) {
        if (response.data.success == true) {
          setSectionData(response.data.data);
          setAssigedId(
            isEmptyDash(response.data?.data?.assigneeId)
              ? ""
              : response.data?.data?.assigneeId
          );
        }

        return response.data;
      })
      .catch(function (error) {
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const getDocument = (data) => {
    setIsLoading(true);
    let bodyData = {
      vendorId: id,
      stepId: allStepData?.latestStepId,
      downloadAll: data?.downloadAll,
    };

    if (data?.downloadAll == true) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      let raw = JSON.stringify(bodyData);

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${urlConstants.BASE_URI_DEV}/v1/internal/vendors/documents`,
        requestOptions
      )
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "allDocuments.zip";
          document.body.appendChild(a);
          a.click(); // Simulate click
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading blob:", error);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      vendorServices
        .getDocument(bodyData)
        .then(function (response) {
          if (response.data.success == true) {
            setDocumentDownloadList(response.data?.data?.documents);
            setOpenDownloadModal(true);
            handleClose();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
  };

  const getVendorDetailsById = (data) => {
    setIsLoading(true);
    let param = `?vendorId=${id}`;
    vendorServices
      .getVendorDetailsById(param)
      .then(function (response) {
        if (response.data.success == true) {
          setVendorDetails(response.data.data);
          let onboardingType = response?.data?.data?.vendor?.onboardingType;
          //let onboardingType = response?.data?.data?.vendor[0]?.onboardingType;

          let roleName = UserObj?.role.name;
          
          let secVendorDetailsPermissionInit = _.cloneDeep(secVendorDetailsPermission);
          let obj = {};
          for (let key in secVendorDetailsPermissionInit) {
            obj[key] = getSecPermission(key);
          }
          setSecVendorDetailsPermission(obj);
          
          
          if (
            (onboardingType == "ONBOARDING_WITHOUT_DOCUMENTS" || onboardingType == "REGULAR_ONBOARDING" ||
              onboardingType == "DIRECT_ONBOARDING") &&
            ( obj?.EDIT_VENDOR?.read == true)
          ) {
            setIsVendorEdit(true);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   setIsLoading(true);
  //   getAssignSteps();
  //   // ApproverAssign();
  //   // EvaluateStep("");
  // }, []); // Adding setIsLoading to the dependency array

  const getAssignSteps = (param, param2) => {
    setIsLoading(true);
    return vendorServices
      .getAssignSteps(param)
      .then(function (response) {
        if (response.data.success === true) {
          // if (param2 == "All") {
          setSectionAssignData(response.data.data);
          //  }
          if (param2 == "QUALITY") {
            setQaAssignData(response.data.data);
          }
          if (param2 == "ENGINEERING") {
            setEngineerAssigneeData(response.data.data);
          }
        }
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const approverAssign = (assigneeId) => {
    setIsLoading(true);
    let bodydata = {
      vendorId: id,
      assigneeId: assigneeId,
    };
    return vendorServices
      .approverAssign(bodydata, allStepData?.latestStepId)
      .then(function (response) {
        if (response.data.success === true) {
          setSectionApprovernData(response.data.data);
          setAssigedId(assigneeId);
          openAlert(true, "success", `${response.data.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const evaluateStep = (newStatus, vendorId) => {
    let bodyData;
    if (newStatus === "Hold") {
      bodyData = {
        status: newStatus,
        feedback: feedback,
        vendorId: vendorId,
      };
    } else {
      bodyData = {
        status: newStatus,
        feedback: feedback,
        rating: rating,
        vendorId: vendorId,
      };
    }

    setIsLoading(true);
    vendorServices
      .evaluateStep(bodyData, allStepData?.latestStepId)
      .then(function (response) {
        if (response.data.success === true) {
          setFeedback("");
          setRating(0);
          setOpen1({ isOpen: false, param: "" });
          if (newStatus == "Approved") {
            setOpenApproveModal(true);
          }
          if (newStatus == "Rejected") {
            setOpenRejectModal(true);
          }
          if (newStatus === "Hold") {
            handleSuccess(
              `${activeIndex === 1
                ? "Financial Evaluation"
                : activeIndex === 2
                  ? "Factory Evaluation"
                  : "Profile Evaluation"
              } has been kept on Hold for now`
            );
          }

          // openAlert(true, "success", `${response.data?.message}`);
        }

        // return response.data;
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleApprovebutton = (param) => {
    if (rating === 0 || feedback === "") {
      openAlert(true, "error", `Please enter some text.`);
    } else {
      evaluateStep(param, id);
    }
  };

  const handleHoldbutton = (param) => {
    if (feedback === "") {
      openAlert(true, "error", `Please enter some text.`);
    } else {
      evaluateStep(param, id);
    }
  };

  const navigateUrl = (param) => {
    navigate(param);
  };

  const clearFactoryModalData = () => {
    setVisitData({
      switch: false,
      visitDate: "",
      visitAssign: "",
      visitQAAssign: "",
      visitEmail: "",
      visitRemarks: "",
    });
  };

  const handleSubmit = () => {
    let isValid = true;
    if (visitData["switch"] === false) {
      for (let data in visitData) {
        if (isEmptyDash(visitData[data]) && data !== "switch") {
          isValid = false;
        }
      }
    }
    if (visitData["switch"] === true) {
      if (rating === 0 || feedback === "") {
        isValid = false;
      }
    }
    if (isValid) {
      let obj = {
        vendorId: id,
        isRequired: !visitData?.switch,
        date: Number(
          visitData?.switch ? new Date() : new Date(visitData?.visitDate)
        ),
        remarks: visitData?.visitRemarks,
        assigneeId: visitData?.visitAssign,
        qaAssigneeId: visitData?.visitQAAssign,
        email: visitData?.visitEmail,
      };
      setIsLoading(true);
      vendorServices
        .planFactoryVisit(obj)
        .then(function (response) {
          if (response.data.success === true) {
            if (visitData["switch"] === true) {
              evaluateStep("Approved", id);
            }
            setOpenFactoryVistModal(false);
            setFactorySucessModal(true);
            setVisitData({
              switch: false,
              visitDate: "",
              visitAssign: "",
              visitQAAssign: "",
              visitEmail: "",
              visitRemarks: "",
            });
          }
        })
        .catch(function (error) {
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      openAlert(true, "error", `Please fill out all required fields.`);
    }
  };

  const handleVisitChange = (e) => {
    const { value, name, checked } = e.target;
    let visitDataInit = _.cloneDeep(visitData);
    if (name == "switch") {
      visitDataInit[name] = checked;
    } else {
      visitDataInit[name] = value;
    }
    setVisitData(visitDataInit);
  };

  const viewUrlData = (data) => {
    setIsLoading(true);

    onboardingServices
      .viewUrlData(data)
      .then(function (response) {
        if (response?.data?.success == true) {
          downloadFileWithUrl(
            `${response?.data?.data?.url}`,
            getFileNameByPath(data)
          );
          // axios({
          //   url: `${response?.data?.data?.url}`,
          //   method: "GET",
          //   responseType: "blob",
          //   headers: {
          //     "Access-Control-Allow-Origin": "*",
          //     cors: "no-cors",
          //   },
          // }).then((response) => {
          //   const url = window.URL.createObjectURL(new Blob([response.data]));
          //   const link = document.createElement("a");
          //   link.href = url;
          //   link.setAttribute("download", getFileNameByPath(data));
          //   document.body.appendChild(link);
          //   link.click();
          // });
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const downloadFileWithUrl = (url, fileName) => {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
      headers: {
        "Access-Control-Allow-Origin": "*",
        cors: "no-cors",
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    });
  };

  const changeScreen = (param) => {
    setIsProgressView(param);
  };
  const getMinDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = (today.getMonth() + 1).toString().padStart(2, "0");
    let day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const { latestStepId, steps } = sectionData;
  let latestSteppIndex = -1;
  if (steps && Array.isArray(steps) && steps.length > 0) {
    latestSteppIndex = steps.findIndex(step => step._id === latestStepId);
  } else {
  }

  return (
    <div className="login-forms">
      <div className="text-centers">
        <div className="heading_search_outer">
          <div className="main_heading  vendor_detail_blocklist_tech ">
            <div className="heading_vendor_name">
              <h1 className="vendor_detail_responsive_reacts1">
                <div class="div-details-center react_technical_vendordetail22">
                  <button
                    onClick={() => navigate(-1)}
                    className="technical_vendordetail2_backbtn"         
                  >
                    <img
                      src={back}
                      alt="back-button"
                      style={{ paddingRight: "3px" }}
                    />{" "}
                    Back
                  </button>
                </div>
                Vendors Details
              </h1>
            </div>

            <div className="date_download">
              <div className="latest_date">
                Latest Modification Date:
                <span> {strToDate(allStepData?.latestModificationDate)} </span>
              </div>
              {activeStep <= 2 && (
                <>
                  {" "}
                  <div>
                    <button
                      className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    >
                      <GetAppIcon />
                      Download
                      <ArrowDropDownIcon />
                    </button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        onClick={() => getDocument({ downloadAll: true })}
                      >
                        <DownloadForOfflineOutlinedIcon />
                        Download All
                      </MenuItem>
                      <MenuItem
                        onClick={() => getDocument({ downloadAll: false })}
                      >
                        {" "}
                        <DownloadForOfflineOutlinedIcon />
                        Download Manually
                      </MenuItem>
                    </Menu>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="vendor_name_status">
          <div className="vendor_name">
            Vendor Name
            <br />
            <span> {vendorDetails?.vendor?.vendorName}</span>
          </div>

          {isProgressView == false && (
            <>
              {" "}
              <div className="vendor_status_main justify-content-between ms-auto">
                <Box sx={{ width: "100%" }}>
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {allStepData?.steps?.map((ele) => (
                      <Step key={ele?._id}>
                        <StepLabel sx={progr_pad}>
                          {ele?.progressName}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </div>
            </>
          )}
        </div>

        {isProgressView == false && (
          <>
            <div className="one_two_main">
              <div className="one_div">
                <ul>
                  {allStepData?.tabs.map((ele, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        handleClick1(ele, i);
                      }}
                    >
                      <div
                        className={
                          activeIndex === i
                            ? "sub-route-sec-div1 sub-route-sec-div-active-detail"
                            : ""
                        }
                      >
                        {ele?.stepName}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="approve_hold_reject">
              {(vendorDetails?.vendor?.status !== "Rejected") && <div className="approve_button justify-content-end">
                {
                  (vendorDetails?.vendor?.onboardingType !== 'DIRECT_ONBOARDING' &&
                    vendorDetails?.vendor?.onboardingType !== 'ONBOARDING_WITHOUT_DOCUMENTS') &&
                  activeStep === 1 &&
                  allStepData?.assigneeId === UserObj?._id && (
                    <div className="row" style={{ width: "347px" }}>
                      <div className="col-sm-6">
                        <span>Planned visit Date</span>
                        <br />
                        {allStepData?.plannedVisitDate ? (
                          <span>
                            {new Date(allStepData.plannedVisitDate).toLocaleDateString("en-US", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}
                          </span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <span>Actual visit Date</span>
                        <br />
                        {allStepData?.actualVisitDate ? (
                          <span>
                            {new Date(allStepData.actualVisitDate).toLocaleDateString("en-US", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}
                          </span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </div>
                    </div>
                  )}

                {(vendorDetails?.vendor?.onboardingType !== 'DIRECT_ONBOARDING' &&
                  vendorDetails?.vendor?.onboardingType !== 'ONBOARDING_WITHOUT_DOCUMENTS') && activeStep === 1 &&
                  allStepData?.stepStatus === "Pending" &&
                  allStepData?.factoryVisitStatus === "Pending" &&
                  allStepData?.assigneeId === UserObj?._id && (
                    <button onClick={setOpenFactoryVistModal} className="btn btn-success">
                      Plan Factory Visit
                    </button>
                  )}

                {(vendorDetails?.vendor?.onboardingType !== 'DIRECT_ONBOARDING' &&
                  vendorDetails?.vendor?.onboardingType !== 'ONBOARDING_WITHOUT_DOCUMENTS') && activeStep === 1 &&
                  allStepData?.factoryVisitStatus === "Visited" &&
                  allStepData?.assigneeId === UserObj?._id && (
                    <button onClick={() => handleOpens1("Approved")} className="btn btn-success">
                      Approve
                    </button>
                  )}

                {allStepData?.assigneeId == UserObj?._id && (
                  <>
                    {(vendorDetails?.vendor?.onboardingType === 'DIRECT_ONBOARDING' ||
                      vendorDetails?.vendor?.onboardingType === 'ONBOARDING_WITHOUT_DOCUMENTS') && (vendorDetails?.vendor?.isOnboarded !== true || vendorDetails?.vendor?.status !== 'Onboarded') && (
                        (activeStep === 0 || activeStep === 2 || activeStep === 3) && (
                          <a className="btn btn-success" onClick={() => handleOpens1("Approved")}>
                            {activeStep === 0 && "Approve Profile"}
                            {activeStep === 2 && "Taxation Approve"}
                            {activeStep === 3 && "Accounts Approve"}
                          </a>
                        )
                      )}
                    {(vendorDetails?.vendor?.onboardingType === 'REGULAR_ONBOARDING') && (activeStep === 0 || activeStep === 3 || activeStep === 4) && (vendorDetails?.vendor?.isOnboarded !== true || vendorDetails?.vendor?.status !== 'Onboarded') && (
                      <a className="btn btn-success" onClick={() => handleOpens1("Approved")} >
                        {activeStep === 0 && "Approve Profile"}
                        {activeStep === 3 && "Taxation Approve"}
                        {activeStep === 4 && "Accounts Approve"}
                        {/* {activeStep === 2 && "Approve" } */}
                      </a>
                    )}
                  </>
                )}

                {allStepData?.assigneeId === UserObj?._id && (vendorDetails?.vendor?.isOnboarded !== true || vendorDetails?.vendor?.status !== 'Onboarded') &&
                  allStepData?.steps?.find(step => step._id === allStepData?.latestStepId)?.uniqueName !== 'thirdParty' &&
                  allStepData?.steps?.find(step => step._id === allStepData?.latestStepId)?.uniqueName !== 'vendorSapCreation' && (
                    <a
                      onClick={() => handleOpens1("Hold")}
                      className="btn btn-warning"
                    >
                      Hold
                    </a>
                  )}
                {allStepData?.assigneeId == UserObj?._id && (vendorDetails?.vendor?.isOnboarded !== true || vendorDetails?.vendor?.status !== 'Onboarded') &&
                  allStepData?.steps?.find(step => step._id === allStepData?.latestStepId)?.uniqueName !== 'thirdParty' &&
                  allStepData?.steps?.find(step => step._id === allStepData?.latestStepId)?.uniqueName !== 'vendorSapCreation' && (
                    <a
                      onClick={() => handleOpens1("Rejected")}
                      className="btn btn-danger"
                    >
                      Reject
                    </a>
                  )}

              </div>}

              {allStepData?.assigneeId == UserObj?._id && vendorDetails?.vendor?.status !== "Rejected" && (vendorDetails?.vendor?.isOnboarded !== true || vendorDetails?.vendor?.status !== 'Onboarded') && (
                <div className="assigned_to justify-content-end">
                  <label className="mb-1 text-dark">Assign To: </label>

                  <select
                    className="form-select vendorlrlist from-hs"
                    onChange={(e) => approverAssign(e.target.value)}
                    value={assigedId}
                  >
                    <option className="from hs" value="">
                      Select an option
                    </option>
                    {sectionAssignData &&
                      sectionAssignData?.assignees?.length > 0 &&
                      sectionAssignData?.assignees?.filter((assignee) => assignee.isActive === true)?.map((option, index) => (
                        <option key={index} value={option._id}>
                          {option.name}
                        </option>
                      ))}


                  </select>

                </div>
              )}
              {/* {isVendorEdit === true && (vendorDetails?.vendor?.isOnboarded !== true || vendorDetails?.vendor?.status !== 'Onboarded') && (
                latestSteppIndex < 2 && ( */}
                  
              {isVendorEdit === true && !(vendorDetails?.vendor?.isOnboarded == true || vendorDetails?.vendor?.status == 'Onboarded' || allStepData?.vendorStatus == "SAP Creation Initiated") && (
                  <button
                    onClick={() =>
                      navigateUrl(`/admin/edit-onboarding-from/${id}`)
                    }
                    className="btn btn-primary btn-sm" style={{ float: 'right', marginTop: '6px' }}
                  >
                    <EditIcon className="edit-vendor-ico" />
                    Edit
                  </button>
                )
              }
            </div>
          </>
        )}

        {isProgressView == true && (
          <OnboardingProgress vendorId={id} changeScreen={changeScreen} assigedId={assigedId} />
        )}

        {isProgressView == false && (
          <>
            {" "}
            {activeIndex === 0 && sectionData ? (
              <BusinessInformationStep1
                data={sectionData}
                viewUrlData={viewUrlData}
                changeScreen={changeScreen}
                activeStep={activeStep}
                vendorId={id}
                latestStepId={allStepData?.latestStepId}
              />
            ) : null}
            {activeIndex === 1 ? (
              <TechnicalComplianceStep3
                data={sectionData}
                viewUrlData={viewUrlData}
                vendorId={id}
                changeScreen={changeScreen}
              />
            ) : null}
            {activeIndex === 2 ? (
              <FinancialTaxStep2
                data={sectionData}
                viewUrlData={viewUrlData}
                changeScreen={changeScreen}
                activeStep={activeStep}
                vendorId={id}
                latestStepId={allStepData?.latestStepId}
              />
            ) : null}
            {activeIndex === 3 ? (
              <FinancialTaxStep2
                data={sectionData}
                viewUrlData={viewUrlData}
                changeScreen={changeScreen}
                activeStep={activeStep}
                vendorId={id}
                latestStepId={allStepData?.latestStepId}
              />
            ) : null}
            {activeIndex > 3 ? (
              <TechnicalComplianceStep3
                data={sectionData}
                viewUrlData={viewUrlData}
                vendorId={id}
                changeScreen={changeScreen}
              />
            ) : null}
          </>
        )}

        {/* {isProgressView == false && (
          <div className="div-details-center">
            <button className="" onClick={() => changeScreen(true)}>
              View Progress
            </button>
          </div>
        )} */}
      </div>

      {/* Approve modal */}
      <Modal
        open={opens1?.isOpen}
        onClose={handleCloses1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={styleRating}
          className="lets_block_modal_listing"
          style={{ minWidth: "46%" }}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              {/* {allStepData.steps[activeStep]?.progressName} Evaluation */}

              {allStepData.steps &&
                activeStep < allStepData.steps.length &&
                allStepData.steps[activeStep].progressName &&
                `${allStepData.steps[activeStep].progressName} Evaluation`}

              {/* {activeIndex === 1 ? "Financial  Evaluation" : activeIndex === 2 ? "Factory Evaluation" : "Profile Evaluation"} */}
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={handleCloses1}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              {(opens1?.param == "Approved" || opens1?.param == "Rejected") && (
                <div className="vendor_status_main_rating justify-content-between ms-auto">
                  <div>
                    <p>
                      {" "}
                      Please rate your experience in each of the following
                      areas:{" "}
                    </p>
                    {/* <p>Drag the slider to a point on the scale.</p> */}
                  </div>
                  <Stack spacing={8} className="rating_vendor_detail">
                    <Rating
                      className="rating_status_services_react_detail"
                      name="size-large"
                      onChange={(e) => setRating(e.target.value)}
                      value={rating}
                      size="large"
                    />
                  </Stack>
                </div>
              )}

              <div className="Newvendor_category">
                <label className="mb-1 text-dark">
                  Feedback/Remarks <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="feedbackInput"
                  className="form-control form_h_modal"
                  placeholder="Enter your feedback or remarks"
                  value={feedback}
                  onChange={handleInputChange}
                  required
                />
                <div className="error-message" id="feedbackError"></div>
              </div>
              <div className="approve_button justify-content-end mt-3">
                {opens1?.param == "Approved" && (
                  <button
                    className="btn btn-success"
                    onClick={() => handleApprovebutton(opens1?.param)}
                  >
                    Approve
                  </button>
                )}
                {opens1?.param == "Rejected" && (
                  <button
                    className="btn btn-success"
                    onClick={() => handleApprovebutton(opens1?.param)}
                  >
                    Reject
                  </button>
                )}

                {opens1?.param == "Hold" && (
                  <button
                    className="btn btn-success"
                    onClick={() => handleHoldbutton(opens1?.param)}
                  >
                    Hold
                  </button>
                )}
                <button
                  onClick={() => {
                    setRating(0);
                    setFeedback("");
                    setOpen1({ isOpen: false, param: "" });
                  }}
                  className="btn btn-warning"
                >
                  Discard
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* sucessfully modal */}
      <Modal
        open={openApproveModal}
        onClose={() => navigateUrl(`/admin/vendor-list`)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="lets_block_modal_listing">
          <div className="modal-headers">
            <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => navigateUrl(`/admin/vendor-list`)}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="approvel_btn_successfully">
                <img src={checkcircleImage} alt="" />
                <p className="profile_react_block">


                  <>
                    {(vendorDetails?.vendor?.onboardingType === 'DIRECT_ONBOARDING' || vendorDetails?.vendor?.onboardingType === 'ONBOARDING_WITHOUT_DOCUMENTS') && (
                      activeStep === 1
                        ? "Factory Visit Completed Successfully"
                        : activeStep === 2
                          ? "Financial Approval Successfully"
                          : "Profile Approved Successfully"
                    )}


                    {(vendorDetails?.vendor?.onboardingType === 'REGULAR_ONBOARDING') && (
                      activeStep === 1
                        ? "Factory Visit Completed Successfully"
                        : activeStep === 3
                          ? "Financial Approval Successfully"
                          : "Profile Approved Successfully"
                    )}
                  </>
                </p>
                <button
                  onClick={() => navigateUrl(`/admin/vendor-list`)}
                  className="btn btn-success"
                >
                  {" "}
                  Done
                </button>
                {/* <Link to="/admin/vendor-list" className="btn btn-success">
                  Done
                </Link> */}
              </div>
            </form>
          </div>
        </Box>
      </Modal>

      {/* Hold Modal */}

      <Modal
        open={openHoldModal}
        onClose={() => navigateUrl(`/admin/vendor-list`)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="lets_block_modal_listing">
          <div className="modal-headers">
            <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => navigateUrl(`/admin/vendor-list`)}
            ></button>
          </div>
          <div className="modal-body react_listing_hold_modal">
            <form>
              <div className="approvel_btn_successfully">
                <img src={holdImage} alt="" />
                <p className="profile_react_block">
                  Profile Evaluation has been kept on Hold for now.
                </p>
                <button
                  onClick={() => navigateUrl(`/admin/vendor-list`)}
                  className="btn btn-success"
                >
                  {" "}
                  Done
                </button>
                {/* <a href="#" className="btn btn-success">
                  Done
                </a> */}
              </div>
            </form>
          </div>
        </Box>
      </Modal>

      {/* Reject Modal */}

      <Modal
        open={openRejectModal}
        onClose={() => navigateUrl(`/admin/vendor-list`)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal_react_controlpanel_employees">
          <div className="modal-headers">
            <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => navigateUrl(`/admin/vendor-list`)}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="approvel_btn_successfully">
                <img src={rejectedImage} alt="" />
                <p className="profile_react_block">
                  Profile has been Reject for now
                </p>
                <button
                  onClick={() => navigateUrl(`/admin/vendor-list`)}
                  className="btn btn-success"
                >
                  {" "}
                  Done
                </button>
                {/* <a href="#" className="btn btn-success">
                  Done
                </a> */}
              </div>
            </form>
          </div>
        </Box>
      </Modal>

      {/* Download Modal  */}
      <Modal
        open={opendownloadtModal}
        onClose={() => setOpenDownloadModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDwnlod} className="modal_react_controlpanel_employees">
          <div className="modal-header">
            <h1
              className="modal-title download-modal-title fs-5"
              id="exampleModalLabel"
            >
              Download List
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setOpenDownloadModal(false)}
            ></button>
          </div>
          <div className="modal-body download-list-modal">
            <div id="employeediv">
              <table className="table" id="employeeTable">
                <thead className="">
                  <tr>
                    <th className="vendor_tabels">S.No.</th>
                    <th className="vendor_tabels">Document Name</th>
                    <th className="vendor_tabels">Download</th>
                  </tr>
                </thead>
                <tbody>
                  {documentDownloadList.map((ele, i) => (
                    <>
                      {ele?.files.length > 0 && (
                        <>
                          <tr className="maine_tr_vendor">
                            <td className="text_react_vendor_detail">
                              {i + 1}
                            </td>
                            <td
                              className="text_react_vendor_detail"
                              colSpan={2}
                            >
                              {ele?.question}
                            </td>
                          </tr>
                          {ele?.files.map((fileEle, j) => (
                            <>
                              <tr>
                                <td className="text_react_vendor_detail">{`${i + 1
                                  }.${j + 1}`}</td>
                                <td>{fileEle?.name}</td>
                                <td
                                  className="text-center"
                                  onClick={() => viewUrlData(fileEle?.key)}
                                >
                                  <img src={downloadImage} alt="" />
                                </td>
                              </tr>
                            </>
                          ))}
                        </>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Plane Factory Vist Modal */}
      <Modal
        open={openfactoryvisttModal}
        onClose={() => setOpenFactoryVistModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="lets_block_modal_listing">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Factory Visit Required
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setOpenFactoryVistModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="toggle-container">
                <div className="lets_toggle_nobtn">
                  <h6>Yes</h6>
                  <input
                    type="checkbox"
                    className="toggle-checkbox"
                    id="toggle"
                  />
                  <label for="toggle">
                    <Switch
                      checked={visitData?.switch}
                      onChange={handleVisitChange}
                      name="switch"
                    // value={visitData?.switch}
                    // onChange={(event) => setChecked(event.target.checked)}
                    />
                  </label>
                  <h6>No</h6>
                </div>
              </div>
              {visitData?.switch === true && (
                <>
                  <div className="vendor_status_main_rating justify-content-between ms-auto">
                    <div>
                      <p>
                        {" "}
                        Please rate your experience in each of the following
                        areas:{" "}
                      </p>
                      {/* <p>Drag the slider to a point on the scale.</p> */}
                    </div>
                    <Stack spacing={8} className="rating_vendor_detail">
                      <Rating
                        className="rating_status_services_react_detail"
                        name="size-large"
                        onChange={(e) => setRating(e.target.value)}
                        value={rating}
                        size="large"
                      />
                    </Stack>
                  </div>
                  <div className="Newvendor_category">
                    <label className="mb-1 text-dark">
                      Feedback/Remarks <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="feedbackInput"
                      className="form-control form_h_modal"
                      placeholder="Enter your feedback or remarks"
                      value={feedback}
                      onChange={handleInputChange}
                      required
                    />
                    <div className="error-message" id="feedbackError"></div>
                  </div>
                  {/* <div className="clear_btn_status">
                    <button type="button" className="btn btn-secondary clear_btn" data-dismiss="modal">
                      Clear
                    </button>
                    <button type="button" className="btn btn-success save_next_btn" onClick={() => handleApprovebutton('Approved')} >
                      Submit
                    </button>
                  </div> */}
                </>
              )}
              {/* {visitData?.switch == false && (
                
              )} */}
              {visitData?.switch == false && (
                <div className="row">
                  <div className="col-sm-6">
                    <label className="mb-1 text-dark">
                      Select Engineer <span className="required">*</span>
                    </label>

                    <select
                      className="form-select w-100"
                      // onChange={(e) => approverAssign(e.target.value)}
                      name="visitAssign"
                      onChange={handleVisitChange}
                      value={visitData?.visitAssign}
                    >
                      <option
                        className="leta_react_bloxck_detail"
                        disabled
                        value=""
                      >
                        Select an option
                      </option>
                      {engineerAssigneeData &&
                        engineerAssigneeData?.assignees?.length > 0 &&
                        engineerAssigneeData?.assignees?.map((option, index) => (
                          <option key={index} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-sm-6">
                    <label className="mb-1 text-dark">
                      Select QA <span className="required">*</span>
                    </label>

                    <select
                      className="form-select w-100"
                      // onChange={(e) => approverAssign(e.target.value)}
                      name="visitQAAssign"
                      onChange={handleVisitChange}
                      value={visitData?.visitQAAssign}
                    >
                      <option
                        className="leta_react_bloxck_detail"
                        disabled
                        value=""
                      >
                        Select an option
                      </option>
                      {qaAssignData &&
                        qaAssignData?.assignees?.length > 0 &&
                        qaAssignData?.assignees?.map((option, index) => (
                          <option key={index} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-sm-6">
                    <label className="mb-1 text-dark">
                      Select Date <span className="required">*</span>
                    </label>
                    <input
                      className="form-control form_h_modal"
                      placeholder="Select Date"
                      type="date"
                      name="visitDate"
                      value={visitData?.visitDate}
                      onChange={handleVisitChange}
                      min={getMinDate()}
                    />
                    <div className="error-message" id="emailError"></div>
                  </div>

                  <div className="col-sm-6">
                    <label className="mb-1 text-dark">Email</label>
                    <input
                      type="email"
                      id="emailInput"
                      className="form-control form_h_modal"
                      placeholder="Enter Email"
                      name="visitEmail"
                      onChange={handleVisitChange}
                      value={visitData?.visitEmail}
                    />
                    <div className="error-message" id="emailError"></div>
                  </div>
                </div>
              )}
              {visitData?.switch == false && (
                <div className="Newvendor_category">
                  <label className="mb-1 text-dark">
                    Remarks <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="remarksInput"
                    className="form-control form_h_modal"
                    placeholder="Enter your remarks"
                    name="visitRemarks"
                    onChange={handleVisitChange}
                    value={visitData?.visitRemarks}
                  />
                  <div className="error-message" id="remarksError"></div>
                </div>
              )}
              <div className="clear_btn_status">
                <button
                  type="button"
                  className="btn btn-outline-secondary secondary_btnes"
                  data-dismiss="modal"
                  onClick={clearFactoryModalData}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-success save_next_btn"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Box>
      </Modal>
      {/*Plane Factor Vist sucessfully modal */}
      <Modal
        open={openfactorysucessModal}
        onClose={() => setFactorySucessModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="lets_block_modal_listing">
          <div className="modal-headers">
            <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setFactorySucessModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="approvel_btn_successfully">
                <img src={checkcircleImage} alt="" />
                <p className="profile_react_block">
                  Factory Visit scheduled Successfully.
                </p>

                <Link to="/admin/vendor-list" className="btn btn-success">
                  Done
                </Link>
              </div>
            </form>
          </div>
        </Box>
      </Modal>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <SuccessModal
        open={openModal}
        onClose={handleCloseModal}
        message={successMessage}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {!isEmptyDash(id) && (
        <SupportChat vendorDetails={{ vendor: { _id: id } }} />
      )}
    </div>
  );
}

export default VendorDetails;
